import React from "react";
import { Redirect, Router, Route, Switch } from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";
import Loading from "./components/Loading";
import Login from "./views/login";
import Profile from "./views/profile";
import Plants from "./views/plants";
import Dashboard from './views/dashboard';

import { useAuth0 } from "./react-auth0-spa";
import history from "./utils/history";

import "./App.scss";

import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { isAuthenticated, loading } = useAuth0();

  if (loading) {
    return <Loading />;
  }

  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <Switch>
          <Route exact path="/">
            {isAuthenticated ?
              <Redirect to="/plants" /> :
              <Route path="/" exact component={Login} />
            }
          </Route>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/profile" component={Profile} />
          <PrivateRoute path="/plants" component={Plants} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
